import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
import { ModalEl } from 'common/components/modal';
import { DropMenuEl } from 'common/components/drop-menu';
import { ButtonEl } from 'common/components/button';
import { ItemsMenuEl } from 'common/components/items-menu';
import { SpinnerEl } from 'common/components/spinner';
import { TextHighlightEl } from 'common/components/text-highlight';
import { CheckboxEl } from 'common/components/checkbox';
import { TooltipEl } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';
import { TagInputEl } from 'common/components/tag-input';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { GetHelpLink, GetUpsellBanner, ShareSection } from './helpers'; // eslint-disable-next-line sonarjs/cognitive-complexity

export function template() {
  const {
    availableMembers,
    availableTeams,
    copyLinkToolTipText,
    currentGrants,
    pendingCanEdit,
    pendingGrants,
    searchText,
    shortUrlLoading,
    showCopyLinkText,
    showCopyLinkToolTip,
    showPopover
  } = this.state;
  return jsx(ModalEl, {
    attrs: {
      closeable: true,
      'modal-title': this.helpers.isNewStyle() ? "Share this ".concat(this.helpers.getEntityTypeTitle(), " With Others") : "Share With Others",
      'modal-description': "Modal for managing sharing permissions",
      open: this.attr("open")
    }
  }, jsx("div", {
    sel: '.wrapper',
    class: {
      'no-min-height': this.helpers.shouldShowUpsellBanner()
    }
  }, this.helpers.isNewStyle() ? jsx("header", {
    sel: '.modal-header'
  }, "Share this ", this.helpers.getEntityTypeTitle()) : jsx("header", {
    sel: '.modal-header'
  }, "Share"), jsx("div", {
    sel: '.content'
  }, this.helpers.shouldShowUpsellBanner() ? jsx(GetUpsellBanner, {
    helpers: this.helpers
  }) : this.helpers.isSuccessfullyLoaded(currentGrants, availableMembers, availableTeams) ? jsx(null, null, jsx("div", {
    sel: '.picker-wrapper',
    key: 'wrapper',
    hook: {
      insert: (_ref) => {
        let {
          elm
        } = _ref;
        return this.setElmRef("tagInputWrapper", elm);
      }
    }
  }, !this.helpers.isNewStyle() ? jsx("label", {
    attrs: {
      for: "picker"
    }
  }, "Invite Teammates") : null, jsx("div", {
    sel: '.picker-controls'
  }, jsx(TagInputEl, {
    attrs: {
      id: "picker",
      tags: JSON.stringify(this.helpers.picker.getTags()),
      elref: "sharingTagInput",
      placeholder: "Enter People or Team Names...",
      'min-tags': 0,
      'mp-select-attrs': JSON.stringify({
        'disable-search': true,
        sections: this.helpers.getSelectOptions({
          isTagInput: true
        }),
        'menu-width': 120,
        'selected-option': pendingCanEdit ? "Editor" : "Viewer",
        theme: "tertiary",
        'always-show-caret': true,
        elref: "selectShareLevel"
      })
    },
    on: {
      change: this.helpers.picker.handleInputChange,
      focus: this.helpers.picker.handleInputFocus,
      optionSelected: this.helpers.picker.handleLevelSelectChange
    },
    hook: {
      insert: this.helpers.picker.handleMpTagInputInsert
    }
  }), jsx(DropMenuEl, {
    attrs: {
      open: !!searchText && showPopover,
      'prevent-close-selectors': JSON.stringify(["mp-tag-input"])
    },
    hook: {
      insert: (_ref2) => {
        let {
          elm
        } = _ref2;
        return this.setElmRef("dropMenu", elm);
      }
    },
    on: {
      change: this.helpers.picker.handlePopoverChange
    }
  }, jsx(ItemsMenuEl, {
    attrs: {
      'search-filter': searchText,
      'empty-message': "This list is empty",
      elref: "usersAndTeamsMenu"
    },
    props: {
      sections: this.helpers.picker.getMenuSections(),
      keydownProxyEl: this.elmRefs.tagInput
    },
    on: {
      clickItem: this.helpers.picker.handleItemClick
    }
  })), jsx(ButtonEl, {
    sel: '.save-share',
    attrs: {
      disabled: pendingGrants.size === 0,
      elref: "saveNewSharesButton",
      size: ButtonSize.Large,
      theme: this.helpers.isNewStyle() ? ButtonTheme.Primary : ButtonTheme.Secondary
    },
    on: {
      click: this.helpers.picker.handleShareButtonClick
    }
  }, this.helpers.isNewStyle() ? "Share" : "Add"))), jsx("div", {
    attrs: {
      elref: "existingShares"
    },
    key: 'existing-shares',
    class: {
      'existing-shares--new-style': this.helpers.isNewStyle(),
      'existing-shares': !this.helpers.isNewStyle()
    },
    hook: {
      insert: (_ref3) => {
        let {
          elm
        } = _ref3;
        return this.helpers.handleShareSectionInsert(elm);
      }
    }
  }, ShareSection("People", this.helpers.existingShares.getUserGrants(), this.helpers), ShareSection("Teams", this.helpers.existingShares.getTeamGrants(), this.helpers), !this.helpers.isNewStyle() ? jsx("div", {
    sel: '.share-section',
    attrs: {
      elref: "shareSectionProject"
    }
  }, jsx("header", null, "Project"), jsx("ul", {
    sel: '.share-list'
  }, jsx("li", {
    sel: '.project-share'
  }, jsx(CheckboxEl, {
    attrs: {
      checked: Boolean(currentGrants.data.projectShares.length)
    },
    on: {
      click: this.helpers.handleProjectShareCheckboxChange
    }
  }, this.helpers.getProjectShareLabel()), jsx("div", {
    sel: '.controls'
  }, jsx(SelectEl, {
    sel: '.share-level',
    attrs: {
      'disable-search': true,
      'menu-width': 120,
      theme: "tertiary",
      'always-show-caret': true,
      sections: JSON.stringify(this.helpers.getSelectOptions({
        isProject: this.helpers.isNewStyle()
      })),
      'selected-option': this.helpers.getProjectShareSelectOption(),
      disabled: currentGrants.data.projectShares.length === 0,
      elref: "selectShareLevel_".concat(this.attr("project-id")),
      'use-fixed-dropmenu-pos': true
    },
    on: {
      change: this.helpers.handleProjectShareSelectChange
    }
  }))))) : null)) : jsx("div", {
    sel: '.placeholder'
  }, jsx("span", null, "Loading current shares..."), jsx(SpinnerEl, null))), this.helpers.isSuccessfullyLoaded(currentGrants, availableMembers, availableTeams) && this.helpers.isNewStyle() ? jsx("div", {
    sel: '.share-section--new-style',
    attrs: {
      elref: "shareSectionProject"
    }
  }, jsx("header", null, "Project"), jsx("ul", {
    sel: '.share-list'
  }, jsx("li", {
    sel: '.project-share--new-style'
  }, jsx("div", {
    sel: '.display'
  }, jsx("div", {
    sel: '.name-wrapper'
  }, jsx("div", {
    sel: '.name'
  }, this.helpers.getProjectShareLabel()), jsx(TextHighlightEl, {
    attrs: {
      theme: "success",
      text: this.helpers.getProjectShareGrantStatus()
    }
  })), jsx("div", {
    sel: '.subtitle'
  }, "".concat(this.helpers.getProjectMemberCount(), " People"))), jsx("div", {
    sel: '.controls'
  }, jsx(SelectEl, {
    sel: '.share-level--new-style',
    attrs: {
      'disable-search': true,
      'menu-width': 120,
      theme: "tertiary",
      'always-show-caret': true,
      sections: JSON.stringify(this.helpers.getSelectOptions({
        isProject: this.helpers.isNewStyle()
      })),
      'selected-option': this.helpers.getProjectShareSelectOption(),
      disabled: !this.helpers.isNewStyle() && currentGrants.data.projectShares.length === 0,
      elref: "selectShareLevel_".concat(this.attr("project-id"))
    },
    on: {
      change: this.helpers.handleProjectShareSelectChange
    }
  }))))) : null, jsx("footer", {
    sel: '.modal-actions'
  }, this.helpers.shouldShowUpsellBanner() ? GetHelpLink("margin-right: auto", this.helpers.handleHelpClick) : jsx("div", {
    sel: '.copy-link-button-wrapper'
  }, jsx(ButtonEl, {
    sel: '.copy-link-button',
    attrs: {
      theme: ButtonTheme.Tertiary,
      icon: shortUrlLoading ? "spinner" : "link",
      disabled: shortUrlLoading
    },
    on: {
      click: this.helpers.shortUrl.handleCopyLinkClick
    }
  }, "Copy Link"), showCopyLinkToolTip ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Top,
      'always-show': true
    }
  }, copyLinkToolTipText) : null, showCopyLinkText ? jsx("input", {
    sel: '.copy-link-input',
    attrs: {
      type: "text",
      readonly: true
    },
    hook: {
      insert: (_ref4) => {
        let {
          elm
        } = _ref4;
        return this.helpers.handleCopyLinkInputInsert(elm);
      }
    },
    on: {
      click: this.helpers.handleCopyLinkInputClick
    }
  }) : null), this.helpers.shouldShowUpsellBanner() ? jsx(null, null, jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Tertiary,
      style: "margin-left: auto; margin-right: 4px"
    },
    on: {
      click: this.helpers.handleDoneButtonClick
    }
  }, "Cancel"), jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      icon: "share",
      href: "/pricing",
      target: "_blank"
    },
    on: {
      click: this.helpers.handleUpsellButtonClick
    }
  }, "Upgrade Plan")) : this.helpers.isNewStyle() ? jsx(null, null, !showCopyLinkText ? jsx("span", {
    sel: '.link-info'
  }, "Project members with this link can view") : null, GetHelpLink("margin-left: auto", this.helpers.handleHelpClick)) : jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      style: "margin-left: auto"
    },
    on: {
      click: this.helpers.handleDoneButtonClick
    }
  }, "Done"))));
}